import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';
import './TingeeThirdParty.scss';
import { THIRDPARTY_CODE } from 'constants/app';
import useThirdPartyConfigForm from './hooks/useThirdPartyConfigForm';
import ThirdPartyConfigLayout from './components/ThirdPartyConfigLayout';

const GtelPayGatewayThirdParty = ({ id, setOpenContent, setId }) => {
  const { t: translation } = useTranslation();
  const [form] = useForm();

  const {
    loading,
    isConnected,
    hasFormChanged,
    showConfirmTest,
    setShowConfirmTest,
    handleSubmit,
    handleConfirmAndSave,
    handleValuesChange,
  } = useThirdPartyConfigForm({
    id,
    setId,
    form,
    translation,
    thirdPartyCode: THIRDPARTY_CODE.GTELPAY_GATEWAY,
    mapFromPartyRequiredData: (partyRequiredData = {}, res = {}) => ({
      merchant_code: partyRequiredData?.merchant_code || '',
      password: partyRequiredData?.password || '',
      isEnable: res?.partyEnableStatus === 1,
    }),
    buildTestPayload: (values = {}) => ({
      merchant_code: values.merchant_code,
      password: values.password,
    }),
    buildUpdatePayload: (values = {}, isConnectedLocal) => ({
      data: {
        partyRequiredData: {
          merchant_code: values.merchant_code,
          password: values.password,
        },
        partyActiveStatus: isConnectedLocal ? 1 : 0,
        partyEnableStatus: values.isEnable ? 1 : 0,
      },
    }),
    testApi: ThirdPartyIntegration.testConfigsGtelPayGateway,
    updateApi: ThirdPartyIntegration.updateConfigsGtelPayGateway,
  });

  return (
    <ThirdPartyConfigLayout
      loading={loading}
      form={form}
      translation={translation}
      title={`Cài đặt tài khoản ${translation('expand_setting.GTELPAY_GATEWAY')}`}
      isConnected={isConnected}
      hasFormChanged={hasFormChanged}
      onBack={() => setOpenContent('')}
      onFinish={handleSubmit}
      onValuesChange={handleValuesChange}
      showConfirmTest={showConfirmTest}
      setShowConfirmTest={setShowConfirmTest}
      onConfirmAndSave={handleConfirmAndSave}
    >
      <Form.Item required label='Merchant Code' name='merchant_code' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Password' name='password' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
    </ThirdPartyConfigLayout>
  );
};

export default GtelPayGatewayThirdParty;
